import React from 'react'
import './institute.css'
import institute from '../../images/institute_images/institute_banner.jpg'
import { NavLink} from 'react-router-dom'
import workshop_icon from '../../images/institute_images/workshop_icon.png'
import course_icon from '../../images/institute_images/course_icon.png'
import video_icon from '../../images/institute_images/video_icon.png'
import corporate_icon from '../../images/institute_images/training_icon.png'
import blog_icon from '../../images/institute_images/blog_icon.png'
import recipe_icon from '../../images/institute_images/recipe_icon.png'
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect,useState } from 'react'

function Institute() {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Initialize AOS
        AOS.init({ duration: 1500, easing: 'ease-in-out' });
    }, []);
    
    useEffect(() => {
        // Simulate loading time
        const timer = setTimeout(() => {
          setLoading(false); // Set loading to false after content is loaded
        }, 1500); // Adjust time as needed
    
        return () => clearTimeout(timer); // Cleanup the timer on unmount
      }, []);
    return (
        <>
        {/* Loader */}
        {loading &&  <div className="loader-container">
          <div className="loader"></div>
          <img src="/images/logo192.png" alt="Anuyog Icon" className="loader-icon" />
        </div>  }
    
    
        {!loading && (
          <>
            <section className='consultancy-section'>
                <div className="consultancy">
                    <img src={institute} alt="" />
                    <h1 className='consultancy-heading  '>RIGHT DECISIONS COME WITH <br /> THE RIGHT KNOWLEDGE</h1>
                </div>
            </section>

            <section className='work-section '>
                <div className="container">
                    <div className="work">
                        <div className="work-text" >
                            <h3
                                className='fonts text-center text-dark mb-4 fw-bold offering-title'
                                style={{ maxWidth: '730px', margin: '0 auto' }}>
                                <strong style={{ color: '#9D3B24' }}> Our goal</strong> is to empower you with the knowledge to take charge of 
                                <strong style={{ color: '#9D3B24' }}> your health, prevent illnesses, and inspire others</strong> to lead
                                <strong style={{ color: '#9D3B24' }}> balanced and sustainable lives. </strong>
                            </h3>
                        </div>
                    </div>
                </div>
            </section>

            <section className='offering-section'>
                <div className="container">
                    <div className="offerings">
                        <h1 className='custom text-center' >
                            {/* <img src={icon} alt="" style={{ height: '52px', width: '65px', marginRight: '20px' }} /> */}
                            The Anuyog Institute Offerings 
                        </h1>
                        <h4 className='text-center fw-bold offering-title'>We’ve got you covered with the resources you need for a healthier, balanced life.</h4>
                        <div className="all_offers institute-detail">
                            <NavLink
                                to="/workshop"
                                className={({ isActive }) => (isActive ? 'main-active' : '')}
                                onClick={() => {
                                    window.scrollTo(0, 0);
                                }}
                            >
                                <div className="offers institute" data-aos="fade-down" data-aos-duration="2000">

                                    <div className="offering-icon">
                                        <img src={workshop_icon} alt="" />
                                    </div>
                                    <div className="offering-text">
                                        <h4 className='fw-bold'>Workshops</h4>
                                        <p > Interactive sessions to explore natural wellness practices.</p>
                                    </div>
                                </div>
                            </NavLink>

                            <NavLink
                                to="/course"
                                className={({ isActive }) => (isActive ? 'main-active' : '')}
                                onClick={() => {
                                    window.scrollTo(0, 0);
                                }}
                            >
                                <div className="offers institute" data-aos="fade-down" data-aos-duration="2000">

                                    <div className="offering-icon">
                                        <img src={course_icon} alt="" />
                                    </div>
                                    <div className="offering-text">
                                        <h4 className='fw-bold'> Courses </h4>
                                        <p >Dive into in-depth learning of holistic health principles.</p>
                                    </div>
                                </div>
                            </NavLink>
                            <NavLink
                                to="/video"
                                className={({ isActive }) => (isActive ? 'main-active' : '')}
                                onClick={() => {
                                    window.scrollTo(0, 0);
                                }}
                            >
                                <div className="offers institute" data-aos="fade-down" data-aos-duration="2000">

                                    <div className="offering-icon">
                                        <img src={video_icon} alt="" />
                                    </div>
                                    <div className="offering-text">
                                        <h4 className='fw-bold'>Videos</h4>
                                        <p>Watch expert-led content for practical lifestyle guidance.</p>
                                    </div>

                                </div>
                            </NavLink>
                            <NavLink
                                to="/"
                                className={({ isActive }) => (isActive ? 'main-active' : '')}
                                onClick={() => {
                                    window.scrollTo(0, 0);
                                }}
                            >
                                <div className="offers institute" data-aos="fade-up" data-aos-duration="2000">

                                    <div className="offering-icon">
                                        <img src={corporate_icon} alt="" />
                                    </div>
                                    <div className="offering-text">
                                        <h4 className='fw-bold'>
                                            Trainings (Coming Soon)</h4>
                                        <p>Build a healthier, more productive workplace.</p>
                                    </div>

                                </div>
                            </NavLink>
                            <NavLink
                                to="/"
                                className={({ isActive }) => (isActive ? 'main-active' : '')}
                                onClick={() => {
                                    window.scrollTo(0, 0);
                                }}
                            >
                                <div className="offers institute" data-aos="fade-up" data-aos-duration="2000">

                                    <div className="offering-icon">
                                        <img src={blog_icon} alt="" />
                                    </div>
                                    <div className="offering-text">
                                        <h4 className='fw-bold'>Blogs (Coming Soon)</h4>
                                        <p>Gain Insights into natural living, health, and wellness.</p>
                                    </div>

                                </div>
                            </NavLink>
                            <NavLink
                                to="/"
                                className={({ isActive }) => (isActive ? 'main-active' : '')}
                                onClick={() => {
                                    window.scrollTo(0, 0);
                                }}
                            >
                                <div className="offers institute" data-aos="fade-up" data-aos-duration="2000">

                                    <div className="offering-icon">
                                        <img src={recipe_icon} alt="" />
                                    </div>
                                    <div className="offering-text">
                                        <h4 className='fw-bold'>Recipes (Coming Soon)</h4>
                                        <p>Healthy, nature-aligned recipes certified by Naturopathy doctors.</p>
                                    </div>

                                </div>
                            </NavLink>
                            
                        </div>
                        <div className="how">
                            <NavLink
                                to="/contact"
                                onClick={() => {
                                    window.scrollTo(0, 0);
                                }}
                            >
                                <button type="button" className="btn">Contact Us for inquiries</button>
                            </NavLink>
                        </div>
                    </div>
                </div>
            </section>

            </>
    )}
    
    </>
  )
}
export default Institute
